export default __webpack_public_path__ + "static/media/facebook.9de605f4.svg";